var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('Navbar',{attrs:{"isLoggedIn":_vm.isLoggedIn,"displayname":_vm.displayname,"selectedCustomer":_vm.selectedCustomer,"app":{
        userProfile: _vm.userProfile, 
        restApi: _vm.restApi,
        reset: _vm.reset
      },"auth":_vm.auth}}),_c('v-content',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',[_c('ProgressSpinner',{attrs:{"isLoading":!!_vm.isLoading,"value":_vm.progressVal,"linear":_vm.progressLinear,"backgroundColor":"#000"}}),_c('router-view',{attrs:{"isLoggedIn":_vm.isLoggedIn,"systemId":_vm.systemId,"app":{
                restApi: _vm.restApi,
                userProfile: _vm.userProfile,
                isLoading: _vm.isLoading,
                setUserProfile: _vm.setUserProfile,
                reset: _vm.reset
              },"setProgressVal":_vm.setProgressVal,"setProgressLinear":_vm.setProgressLinear,"auth":_vm.auth}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }